/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var FireIcon = createIcon({
  name: 'FireIcon',
  height: 512,
  width: 384,
  svgPath: 'M216 23.858c0-23.802-30.653-32.765-44.149-13.038C48 191.851 224 200 224 288c0 35.629-29.114 64.458-64.85 63.994C123.98 351.538 96 322.22 96 287.046v-85.51c0-21.703-26.471-32.225-41.432-16.504C27.801 213.158 0 261.332 0 320c0 105.869 86.131 192 192 192s192-86.131 192-192c0-170.29-168-193.003-168-296.142z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default FireIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/fire-icon.js
// module id = 599
// module chunks = 0